import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useBooking } from '@features/booking/state';

/**
 * Staff/Platform booking redirect for `/staff` and `/platform` routes.
 *
 * Sets the staff booking flag and immediately starts the booking flow.
 * Both `/staff` and `/platform` have identical behavior — the flag
 * modifies how the reservation is submitted (marks as `meitreNetwork`).
 *
 * Replicates the legacy AngularJS `home.staff` / `home.platform` routes.
 */
const StaffBookingRedirectPage = () => {
  const navigate = useNavigate();
  const booking = useBooking();

  useEffect(() => {
    booking.updateBooking({
      specialEvent: null,
      isStaffBooking: true,
    });
    navigate('/select-diners', { replace: true });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-brand" />
    </div>
  );
};

export default StaffBookingRedirectPage;
